import { request } from "@octokit/request";

export const git = {
  user: {
    /*  name
          url
          profilPicUrl   
      */
  },
  commits: [
    /*  title
          date
          url
      */
  ],
};

const createGitObject = function (res) {
  const { data } = res;

  git.user = {
    name: data[0].author.login,
    url: data[0].author.html_url,
    profilPicUrl: data[0].author.avatar_url,
  };

  data.forEach((day) => {
    const commit = {
      title: day.commit.message,
      date: new Date(day.commit.committer.date),
      url: day.html_url,
    };
    git.commits.push(commit);
  });
};

export const loadGit = async function () {
  try {
    const res = await request("GET /repos/{owner}/{repo}/commits", {
      owner: "MCCP96",
      repo: "codewars",
      per_page: 100,
    });

    createGitObject(res);
  } catch (err) {
    throw err;
  }
};
